import React, { useState, useEffect } from 'react';
import { Form, Button, Alert, Spinner } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { useResetPasswordOTPMutation, useLoginMutation } from '../../redux/services/authApi';
import { useTranslation } from 'react-i18next';
import headerImage from "../../assets/images/MysticTan_Unity_Logo_Black.png";
import "./login.css"; // reuse styling

const ResetPasswordOTP = () => {
  const { t } = useTranslation("translation", { keyPrefix: "resetPassword" });
  const navigate = useNavigate();
  const location = useLocation();

  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [password, setpassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [lastTried, setLastTried] = useState(false);
  const [login, { isLoading: loginLoading, isSuccess: loginSuc, isError: loginIsError, error: loginError }] = useLoginMutation();

  // 🔹 new mutation
  const [resetPasswordOTP, { isLoading, isSuccess, error }] = useResetPasswordOTPMutation();

  // auto-fill OTP & email from URL params like /reset?otp=XXXX&email=user@example.com
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const otpParam = params.get('otp');
    const emailParam = params.get('email');
    if (otpParam) setOtp(otpParam);
    if (emailParam) setEmail(emailParam);
  }, [location.search]);

  // password strength checker
  const validatePassword = (pw) => {
    if (pw.length < 8) return "Password must be at least 8 characters.";
    if (!/[A-Z]/.test(pw)) return "Include at least one uppercase letter.";
    if (!/[0-9]/.test(pw)) return "Include at least one number.";
    return '';
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const err = validatePassword(password);
    if (err) {
      setPasswordError(err);
      return;
    }
    setPasswordError('');
    setLastTried(true);
    try {
      await resetPasswordOTP({ email, otp, password }).unwrap();
      // navigate("/login") after success if needed
    } catch (err) {
      console.error("Password reset failed:", err);
    }
  };

  useEffect(() => {
    // Force login on create user
    if (isSuccess) {
      login({ email, password }).unwrap();
    }
  }, [isSuccess])
  return (
    <div className="">
      <div className='unityHeader'>
        <div className="login-header-image">
          <img src={headerImage} alt="logo" />
        </div>
      </div>
      <div className='prettyLogin'>
        <div className="formContainer">
          <div className='header'>
            <h1>{t("header.reset", "Reset Your Password").toUpperCase()}</h1>
          </div>
          <Form onSubmit={handleSubmit}>
            <p className='reset-instructions'>{t("header.otpMessage", "Please enter the OTP sent to your email to finish the password reset.")}</p>

            {/* EMAIL */}
            <Form.Group controlId="formEmail" className='formInput'>
              <Form.Control
                type="email"
                placeholder={t("email.placeholder", "Email Address")}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={!!new URLSearchParams(location.search).get('email')} // disable if auto-filled
              />
            </Form.Group>

            {/* OTP */}
            <Form.Group controlId="formOtp" className='formInput'>
              <Form.Control
                type="text"
                placeholder={t("otp.placeholder", "Enter OTP")}
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                required
              />
            </Form.Group>

            {/* NEW PASSWORD */}
            <Form.Group controlId="formpassword" className='formInput'>
              <Form.Control
                type="password"
                placeholder={t("password.placeholder", "New Password")}
                value={password}
                onChange={(e) => setpassword(e.target.value)}
                required
              />
            </Form.Group>

            {/* Alerts */}
            {passwordError && <Alert variant="danger">{passwordError}</Alert>}
            {error && !passwordError && <Alert variant="danger">{t("alert.fail", "Password reset failed.")}</Alert>}
            {isSuccess && !passwordError && <Alert variant="success">{t("alert.success", "Password successfully reset!")}</Alert>}

            <Button variant="primary" type="submit" disabled={isLoading} className='loginButton'>
              {isLoading ? <Spinner animation="border" size="sm" /> : t("button.reset", 'Reset Password')}
            </Button>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordOTP;
